
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogWishlistButton',
  props: {
    slug: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['add', 'remove'],
  methods: {
    onClick() {
      if (this.active) {
        this.$emit('remove', this.slug)
      } else {
        this.$emit('add', this.slug)
      }
    },
  },
})
